import { NgModule } from '@angular/core';
import { TransferHttpCacheModule } from '../core';
import { FuseMainComponent } from './atlas.component';
import { AppModule } from './app/app.module';
import { TemplateAtlasSharedService } from './ecap/shared.services';
import { ToolbarTriggerService } from './ecap/trigger.service';
//import { PlatformModule } from '@angular/cdk/platform';
import { EcapBroadcastService } from './ecap/services/ecap-broadcast.service';
@NgModule({
    imports: [
        TransferHttpCacheModule.forRoot(),
        //PlatformModule,
        AppModule
    ],
    declarations: [FuseMainComponent],
    providers: [TemplateAtlasSharedService, ToolbarTriggerService, EcapBroadcastService],
    exports: [FuseMainComponent]
})
export class FuseMainModule {}
